import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { memo, useRef, useCallback, useEffect, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeCustomerData } from "@nxplatform/geo-data/slices/ip-data.slice";
import { lazyImport } from "@nxplatform/helpers/helpers";
import { BaseApplicationLanguage } from "@nxplatform/platform-settings/locale-setup.shared";
import { customerOpenBasicModal } from "@nxplatform/store-shared/customer/shared-customer-actions";
import { selectCustomerTokenEntities } from "@nxplatform/store-shared/customer/shared-customer-selectors";
import { addAliveChannels, selectPublicWsConnectionAliveChannels, removeAliveChannels } from "@service/api-client/slices";
import { useFooterUpdate } from "./facades/route-switcher/footer-update.facade.js";
import { usePromotionsEvents } from "./facades/route-switcher/promotions-events.facade.js";
import { AuthorizationHookWrapper as _AuthorizationHookWrapper } from "./hooks/authorization/authorization.hook.wrapper.js";
import { CallbackAfterRegistrationWrapper as _CallbackAfterRegistrationWrapper } from "./hooks/callback-after-registration/callback-after-registration-wrapper.js";
import { useCasinoGamesOnlinePlayers } from "./hooks/casino-games-online-players.hook.js";
import { useGameRecommendationByLangHook } from "./hooks/game-recommendation-by-lang.hook.js";
import { PlayLimitCheckWrapper as _PlayLimitCheckWrapper } from "./hooks/play-limit-check/play-limit-check.wrapper.js";
import { useReferralProgramHook } from "./hooks/referralProgram.hook.js";
import { TopBluemRegistrationWrapper as _TopBluemRegistrationWrapper } from "./hooks/top-bluem-registration/top-bluem-registration-wrapper.js";
import { selectMainRecommendedNonAuthEnabled, selectPlatformSettingsIsText } from "@nxplatform/platform-settings/platform-settings.selectors";
const { LazyHooksWrapper } = lazyImport(() => import("@nxplatform/platform-common/lazy-hooks.wrapper"), "LazyHooksWrapper");
const RootLazyHooks = () => {
  const linkRef = useRef(null);
  const dispatch = useDispatch();
  const auth = useSelector(selectCustomerTokenEntities);
  const langIso = BaseApplicationLanguage;
  const mainRecommendedNonAuthEnabled = useSelector(selectMainRecommendedNonAuthEnabled);
  const isTextPage = useSelector(selectPlatformSettingsIsText);
  const changeBonusType = useCallback((payload) => {
    return dispatch(changeCustomerData({ bonusType: payload }));
  }, []);
  const openModal = useCallback((modalType) => {
    return dispatch(customerOpenBasicModal(modalType));
  }, []);
  const addPublicWsChannels = useCallback((payload) => {
    dispatch(addAliveChannels(payload));
  }, []);
  const publicWsAliveChannels = useSelector(selectPublicWsConnectionAliveChannels);
  const removePublicWsChannels = useCallback((payload) => {
    return dispatch(removeAliveChannels(payload));
  }, []);
  useGameRecommendationByLangHook({
    auth,
    langIso,
    mainRecommendedNonAuthEnabled
  });
  usePromotionsEvents({
    isTextPage,
    linkRef,
    openModal,
    changeBonusType
  });
  useCasinoGamesOnlinePlayers({
    isTextPage,
    addPublicWsChannels,
    publicWsAliveChannels,
    removePublicWsChannels
  });
  useFooterUpdate();
  useReferralProgramHook({ appReady: true });
  useEffect(() => {
    if (!auth) {
      !!document.pictureInPictureElement && document.exitPictureInPicture();
    }
  }, [auth]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    auth && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(LazyHooksWrapper, {}) }),
      /* @__PURE__ */ jsx(_PlayLimitCheckWrapper, {})
    ] }),
    /* @__PURE__ */ jsx(_CallbackAfterRegistrationWrapper, {}),
    /* @__PURE__ */ jsx(_TopBluemRegistrationWrapper, {}),
    /* @__PURE__ */ jsx(_AuthorizationHookWrapper, {})
  ] });
};
const _RootLazyHooks = memo(RootLazyHooks);
export {
  _RootLazyHooks as RootLazyHooks
};
